import PropTypes from 'prop-types';
import { useState } from 'react';
import { configVars } from 'src/helpers';

const OutboundIntegrationLogo = ({
  propertyId
}: {
  propertyId: string | undefined;
}): JSX.Element | null => {
  const [imageErrored, setImageErrored] = useState(false);

  if (!propertyId || imageErrored) {
    return null;
  }

  return (
    <img
      alt="OIF Provider"
      src={`${configVars.epa_url}/internal/properties/${propertyId}/integration-logo`}
      style={{ width: 70, alignSelf: 'center' }}
      onError={() => setImageErrored(true)}
    />
  );
};

OutboundIntegrationLogo.propTypes = {
  propertyId: PropTypes.string
};

export default OutboundIntegrationLogo;
